import { createContext } from "react"
import type { TConfig } from "@/types"

export const ConfigContext = createContext<TConfig | null>(null)
